// extracted by mini-css-extract-plugin
export default {"accordion":"styles_accordion__nxeNa","accordion-blocked":"styles_accordion-blocked__jDkB+","chat":"styles_chat__y4NR3"};